var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.96,
    height: 13.2,
    viewBox: "0 0 9.96 13.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09,12.16l.007-.006A2.588,2.588,0,0,1,0,9.518a.8.8,0,0,1,.007-.08V.275A.263.263,0,0,1,.256,0H9.711A.263.263,0,0,1,9.96.275V12.65a.526.526,0,0,1-.5.55Zm1.69-3.754,4.936,3.2V1.375H1.251V9.48c0,.024,0,.06,0,.085A1.183,1.183,0,0,0,2.408,10.8,1.229,1.229,0,0,0,3.569,9.518c0-.016,0-.03,0-.046V8.534c0-.1.045-.164.111-.164A.177.177,0,0,1,3.779,8.407Zm-1.368-2.3V5.285H7.541v.822Zm0-1.976V3.309H7.541v.822Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.68fd4fb6.svg";
export { ForwardRef as ReactComponent };